import React from 'react';

export default React.createContext({ setTitle: () => {}, setIcon: () => {} });
